import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next'
import {Box, Grid, Typography} from "@mui/material"
import {useAppDispatch} from "../../store/store";
import {sendEventsData} from "../../store/actions/actions";


const InfoPageTreeSizeLayout = () =>{
    const {t} = useTranslation()
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/info/tree-size",
            type:"pageView"
        }))
    });
    const data = [
        { key: 10, value: "<10" },
        { key: 20, value: "10-20" },
        { key: 30, value: "20-30" },
        { key: 40, value: "30-40" },
        { key: 50, value: "40-50" },
        { key: 60, value: "50-60" },
        { key: 70, value: "60-70" },
        { key: 80, value: "70-80" },
        { key: 90, value: "80-90" },
        { key: 100, value: ">90" },
    ]
    return (
        <Box>
            <Typography style={{textAlign:"center"}}  variant="h3" gutterBottom>
                {t('info_page.tree_size.title' as any)}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
                {t('info_page.tree_size.subtitle1' as any)}
            </Typography>
            <Grid container spacing={2} >
                <Grid container style={{alignItems: "center"}} item xs={12} direction="column">
                    <table style={{
                        border: "2px solid black",
                        width: "100%",
                        padding: 16,
                        marginTop: 16,
                        marginBottom: 16
                    }}>
                        <tbody>
                        <tr>
                            <th style={{borderBottom: "2px solid black"}}> {t('info_page.tree_size.table_header' as any)}</th>
                            {data.map((val) => {
                                return (
                                    <td style={{textAlign: "center",borderBottom: "2px solid black"}}>{val.key}</td>
                                )
                            })}
                        </tr>
                        <tr>
                            <th > {t('info_page.tree_size.table_row' as any)}</th>
                            {data.map((val) => {
                                return (<td style={{textAlign: "center"}}>{val.value}</td>)
                            })}
                        </tr>
                        </tbody>



                    </table>
                    <Box
                        component="img"
                        style={{
                            alignContent:"center",
                            minHeight: 500,
                            minWidth: 500,
                            marginBottom: 16
                        }}
                        alt="Tree Size 1"
                        src={require("../../assets/pages/info/common/tree_size.png")}
                    />
                </Grid>
                <br/>
            </Grid>
            <Grid container style={{alignItems: "center", textAlign: "start", marginBottom: 8}} item xs={12}
                  direction="column">
                <Typography variant="body1">
                    {t('info_page.tree_size.subtitle2' as any)}
                </Typography>
            </Grid>
        </Box>
    )


}
export default InfoPageTreeSizeLayout
